import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from '@angular/core';
import { BdState, BdStateStore } from '@bindoc-projects/geographic-domain-lib';
import {
  BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT,
  BdMapsStateSelectOptions,
} from '../../select-options';
import { BdUiMultiSelectComponent, BdUiMultiSelectConfig } from '@bindoc-projects/ui-lib/selection/ui';
import { NEVER, Observable, of } from 'rxjs';

@Component({
  selector: 'bd-maps-state-select-inline-multiple',
  template: `
    <bd-ui-multi-select
      [config]="config"
      [initialSelection]="initialStates()"
      [selectOptions]="options$()"
      (selection)="stateSelect.emit($event)"
    ></bd-ui-multi-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BdUiMultiSelectComponent],
})
export class BdMapsStateSelectInlineMultipleComponent {
  readonly states = input<BdState[]>();
  readonly initialStateIds = input<number[]>();
  readonly options = input<BdMapsStateSelectOptions>(BD_MAPS_STATE_SELECT_OPTIONS_DEFAULT);

  readonly stateSelect = output<BdState[]>();

  public readonly config: BdUiMultiSelectConfig<BdState> = {
    id: 'maps-state-select-inline-multiple',
    selectLabel: { '=1': 'Bundesland', other: 'Bundesländer' },
    option: {
      sortFnc: (a, b) => a.name.localeCompare(b.name),
      uniqueFnc: (option) => option.id.toString(),
      searchOptionAccessor: (option) => option.name,
    },
  };

  readonly options$ = computed<Observable<BdState[]>>(() => {
    const states = this.states();
    return states ? of(states) : NEVER;
  });

  readonly initialStates = computed<BdState[]>(() => {
    const ids = this.initialStateIds();
    return ids ? ids.map((stateId) => BdStateStore.byId(stateId)) : [];
  });
}
